<gl-select
  [label]="label"
  [placeholder]="placeholder"
  [options]="items"
  [value]="selectedItem"
  [attr.disabled]="disabled ? true : null"
  [attr.readonly]="readonly ? true : null"
  [ngClass]="{ min: size === 'min' }"
  (onChange)="onChange($event.detail)"
>
</gl-select>
